import { render } from "./movementDialog.vue?vue&type=template&id=3af57d43&scoped=true"
import script from "./movementDialog.vue?vue&type=script&lang=js"
export * from "./movementDialog.vue?vue&type=script&lang=js"

import "./movementDialog.vue?vue&type=style&index=0&id=3af57d43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af57d43"]])

export default __exports__